import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-user',
  templateUrl: './users-user.component.html',
  styleUrls: ['./users-user.component.scss']
})
export class UsersUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
